import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// import {
//   ResetPasswordRequest,
//   login,
//   LoginRequest,
//   signUp,
//   SignUpRequest,
//   resetPassword,
//   verifySecurityCode,
//   SecurityCodePayload,
//   NewPasswordData,
//   setNewPassword,
// } from '@app/api/auth.api';
import { setUser } from '@app/store/slices/userSlice';
import { deleteToken, deleteUser, persistToken, readToken } from '@app/services/localStorage.service';
import { adminApi, LoginRequest } from '@app/api/admin';
import { notificationController } from '@app/controllers/notificationController';
// import { authApi } from '@app/api/auth';
import { clearUserPermissions } from './userSlice';

export interface AuthSlice {
  token: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: AuthSlice = {
  token: readToken(),
  loading: false,
  error: null,
};

export const doLogin = createAsyncThunk('auth/doLogin', async (loginPayload: LoginRequest, { dispatch }) =>
 {
  console.log('loginPayload',loginPayload)
  return adminApi.login(loginPayload).then((res) => {
    console.log('login', res);
    const { token, user } = res.data;
    dispatch(setUser(user));
    persistToken(token);
     
      notificationController.success({
        message: '登录成功',
        description: '欢迎回来！',
        duration: 1
      });
    return token;
  }).catch((err) => {
    notificationController.error({
      message: '登录失败',
      description: err.message,
    });
  })
 }
);

// export const doSignUp = createAsyncThunk('auth/doSignUp', async (signUpPayload: SignUpRequest) =>
//   signUp(signUpPayload).then((res) => {
//     if (res.code === 200) {
//       return res.data;
//     } else {
//       throw new Error(res.message);
//     }
//   }),
// );

// export const doResetPassword = createAsyncThunk(
//   'auth/doResetPassword',
//   async (resetPassPayload: ResetPasswordRequest) => resetPassword(resetPassPayload),
// );

// export const doVerifySecurityCode = createAsyncThunk(
//   'auth/doVerifySecurityCode',
//   async (securityCodePayload: SecurityCodePayload) => verifySecurityCode(securityCodePayload),
// );

// export const doSetNewPassword = createAsyncThunk('auth/doSetNewPassword', async (newPasswordData: NewPasswordData) =>
//   setNewPassword(newPasswordData),
// );

export const doLogout = createAsyncThunk('auth/doLogout', (payload, { dispatch }) => {
  deleteToken();
  deleteUser();
  dispatch(setUser(null));
});

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Login
    builder.addCase(doLogin.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(doLogin.fulfilled, (state, action) => {
      state.loading = false;
      state.token = action.payload as string;
      state.error = null;
    });
    builder.addCase(doLogin.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || '登录失败';
    });

    // Logout
    builder.addCase(doLogout.fulfilled, (state) => {
      state.token = null;
      state.error = null;
    });

 
  },
});

export default authSlice.reducer;
